import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
// eslint-disable-next-line
import { jsx } from '@emotion/react';
export const Checkbox = ({ label, error, indeterminate, checked, disabled = false, labelPlacement = 'end', dataQa = 'checkbox-core', onChange, }) => {
    return (jsx(FormControl, { error: !!error, "data-qa": dataQa },
        jsx(FormControlLabel, { control: jsx(MuiCheckbox, { checked: checked, disabled: disabled, indeterminate: indeterminate, color: error ? 'error' : 'primary', className: `MuiCheckbox-LabelPlacement-${labelPlacement}`, onChange: onChange, disableRipple: true }), label: label, labelPlacement: labelPlacement, sx: { 'align-items': 'flex-start' } }),
        typeof error === 'string' && (jsx(FormHelperText, { className: `MuiCheckbox-errorLabelPlacement-${labelPlacement}` }, error))));
};
